import React, { useState, useEffect } from "react";
import "./header.css";
import Logo from "../../assets/logo.png";
import LogoNew from "../../assets/logo/newLogo.svg";
import { useLocation, useNavigate } from "react-router-dom";
import profile from "../../assets/user-solid.svg.png";
import { useDispatch } from "react-redux";
import { logout } from "../../redux/loginSlice";
import NotificationPanel from "./NotificationPanel";

// Menu items for the sidebar
const menuItems = [
  { label: "Dashboard", path: "/dashboard" },
  { label: "Registration Management", path: "/registration" },
  { label: "Bond Management", path: "/bond" },
  { label: "Investment Management", path: "/investment-management" },
  { label: "CMS", path: "/cms" },
  { label: "Report", path: "/report" },
  { label: "User Management", path: "/user" },
  { label: "Sell Request", path: "/sell-request" },
  { label: "Invite Partner", path: "/invite-partner" },
  { label: "Relationship Manager", path: "/relationship-manager" },
];

function Header() {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const location = useLocation();
  const dispacth = useDispatch();
  const navigate = useNavigate();

  // Add useEffect to close dropdown when location changes
  useEffect(() => {
    setIsDropdownOpen(false);
  }, [location]);

  // Find the current menu item based on the current path
  const currentMenuItem =
    menuItems.find((item) => location.pathname.startsWith(item.path)) || {};

  const handleLogout = () => {
    console.log("User logged out");
    // Clear pagination data from localStorage
    localStorage.removeItem("bondManagementPage");
    localStorage.removeItem("userManagementPage");
    localStorage.removeItem("investorManagementPage");
    localStorage.removeItem("investmentPartnerPage");
    localStorage.removeItem("registrationManagementPage");
    localStorage.removeItem("registrationManagementPartnerPage");
    localStorage.removeItem("cmsPage");
    localStorage.removeItem("reportPage");
    localStorage.removeItem("dashboardPage");
    localStorage.removeItem("blogPage");
    localStorage.removeItem("announcementPage");
    dispacth(logout());
    navigate("/login");
  };

  return (
    <header className="header-wrapper">
      {/* Left Section: Logo and Title */}
      <div className="header-left">
        <div className="header-logo">
          <img src={LogoNew} alt="Logo" />
        </div>
        <div className="ml-20">
          <h2>{currentMenuItem.label || ""}</h2>
        </div>
      </div>

      {/* Right Section: Profile */}
      <div className="header-right">
        {/* <div className="relative">
          <div 
            className="flex items-center cursor-pointer hover:text-[#0066b2]"
            onClick={() => setIsNotificationOpen(!isNotificationOpen)}
          >
            <span>Notification</span>

          </div>
          <NotificationPanel 
            isOpen={isNotificationOpen} 
            onClose={() => setIsNotificationOpen(false)} 
          />
        </div> */}
        <div
          className={`user-icon ${isDropdownOpen ? "active" : ""}`}
          onClick={() => setIsDropdownOpen((prev) => !prev)}
        >
          <img src={profile} alt="User Profile" className="w-[18px] h-[18px]" />
        </div>
        {isDropdownOpen && (
          <div className="dropdown">
            <ul>
              <li
                className="px-4 py-2 hover:bg-gray-200 cursor-pointer"
                onClick={handleLogout}
              >
                Logout
              </li>
            </ul>
          </div>
        )}
      </div>
    </header>
  );
}

export default Header;
